// extracted by mini-css-extract-plugin
export default {"services":"ServiceSelection_services__7IaTJ","heading-3":"ServiceSelection_heading-3__7QTHB","chips":"ServiceSelection_chips__uMrot"};